// LICENCE: MIT
// Copyright (c) 2023 Brendon Lees
// Augmented `cx()` adapted from https://github.com/brendon1555/panda-cx-deduplicator
type Argument = string | boolean | null | undefined;

const atomicClassRegex = /(.*\]:)?[^_]*(?=_)|.*(?=\]:)/g;

function cx(...args: Argument[]) {
    const presentClassNames = (Array.prototype.slice.call(args) as Argument[])
        .filter(Boolean)
        .filter((arg) => typeof arg === 'string') as string[];

    const atomicClasses: { [k: string]: string } = {};
    const nonAtomicClasses: string[] = [];

    presentClassNames.forEach((arg) => {
        const individualClassNames = arg ? arg.split(' ').filter(Boolean) : [];

        individualClassNames.forEach((className) => {
            const atomicMatch = className.match(atomicClassRegex);
            /* Slot recipes contain `__` */
            if (!className.includes('__') && atomicMatch) {
                const key = atomicMatch[0];
                atomicClasses[key] = className;
            } else {
                nonAtomicClasses.push(className);
            }
        });
    });

    const result: string[] = [];

    for (const key in atomicClasses) {
        if (Object.prototype.hasOwnProperty.call(atomicClasses, key)) {
            result.push(atomicClasses[key]);
        }
    }
    result.push(...nonAtomicClasses);
    return result.join(' ');
}

export { cx };
